import React from "react";
import "./skeletonCategory.css";

const SkeletonLoader = () => {
  const skeletonItems = Array(7).fill(0); // Number of skeleton cards

  return (
    <div className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden">
      {skeletonItems.map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-img"></div>
          <div className="skeleton-text"></div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
